const Tooltip = (() => {
    const $body = $('body');
    const tooltipPopupWrapperHtml = "<div class='tooltip-popup'></div>";
    const tooltipLinkClass = '.tooltip-link';
    const tooltipCloseClass = '.tooltip-close';

    function openMembershipTooltip() {
        $(this).closest('.promotion-row').addClass('open');
        const tooltipHtml = $('.membership-table .promotion-row.open .tooltip').html();
        $body.addClass('tooltip-open').append(tooltipPopupWrapperHtml);
        $('.tooltip-popup').html(tooltipHtml);
    }

    function closeMembershipTooltip() {
        $body.removeClass('tooltip-open');
        $('.tooltip-popup').remove();
        $('.membership-table .promotion-row.open').removeClass('open');
    }

    function initMembershipTooltip() {
        $body.on('click', tooltipLinkClass, openMembershipTooltip);

        $body.on('click', tooltipCloseClass, closeMembershipTooltip);
    }

    return {
        initMembershipTooltip,
    };
})();

export default Tooltip;
